import { createContext, useContext, useEffect } from 'react'

export const WidgetAvailability = createContext(null)

export function useWidgetAvailability(error) {
  const setAvailable = useContext(WidgetAvailability)
  // 404: the warehouse switch is off. 403: a Wager-internal metric (operator
  // totals) on a dashboard shared with an operator's users.
  const status = error?.response?.status
  const available = status !== 404 && status !== 403
  useEffect(() => { setAvailable?.(available); return () => setAvailable?.(true) }, [available, setAvailable])
  return available
}
